import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReservationsForgotPassword from "pages/guest/Reservations/ReservationsForgotPassword";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {
    uiStore: { ...state.uiStore },
    reservationStore: { ...state.reservationStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReservationsForgotPassword);
